import { useEffect, useState } from "react";
import DeviceScreenLayout from "../../components/layouts/DeviceScreenLayout";
import Header from "../../components/layouts/Header";
import { getKnowledgeBases } from "../../api/knowledgeBases";
import { useAuth } from "../../contexts/AuthContext";



const QuestionItem = ({question, answer}) => {
    return (
        <div
            style={{
                background: '#F8F9FF',
                display: 'flex',
                flexDirection: 'column',
                padding: '24px 32px',
                width: '100%',
                borderRadius: '20px',
                gap: '24px',
            }}
        >
            <span
                style={{
                    color: '#4e5968',
                    fontFamily: 'Pretendard',
                    fontSize: '19px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: '140%', // 또는 '26.6px'
                    letterSpacing: '-0.5px',
                }}
            >
                {question}
            </span>

            <p
                style={{
                    color: '#6C7889', // Navy-500 변수값이 없을 경우를 대비한 폴백 컬러
                    fontFamily: 'Pretendard',
                    fontSize: '17px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '150%', // 또는 '25.5px'
                    letterSpacing: '-0.5px',
                }}
            >
                {answer}
            </p>

        </div>
    )
}


const InfosPage = () => {
    const { selectedStore } = useAuth();
    const storeUuid = selectedStore?.uuid;
    const [knowledgeBases, setKnowledgeBases] = useState([]);

    useEffect(() => {
        if (!storeUuid) return;
        getKnowledgeBases(storeUuid)
            .then((data) => {
                console.log(data?.data?.knowledge_bases)
                setKnowledgeBases(data?.data?.knowledge_bases ?? []);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [storeUuid]);

    return (
        <DeviceScreenLayout>
            <>
                <div
                    style={{
                        position: 'absolute',
                        // border: '1px solid green',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        left: 0,
                        zIndex: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'end',
                        justifyContent: 'center',
                        // border: '1px solid green',
                    
                    }}
                
                >
                    {/* 헤더 영역 */}
                    <Header 
                        isBackEnabled={true}
                    />
                    <div
                        style={{
                            flex: 1,
                            background: '#FFFFFF',
                            width: '100%',
                            display: 'flex',
                            padding: '24px',
                            overflowY: 'scroll'
                            // background: 'blue'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                gap: '24px',
                           
                            }}
                        >
                            {
                                knowledgeBases.map((item, index) => (
                                    <QuestionItem
                                        key={index}
                                        question={item?.question}
                                        answer={item?.answer}
                                    />
                                ))
                            }
                            <div style={{ height: '1px', minHeight: '1px' }} />
                        </div>


                    </div>
                    
                </div>
            </>
        </DeviceScreenLayout>
    )
}

export default InfosPage;